import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';
import { Globe } from '../../icons';

type FlagComponent = React.FC<React.SVGProps<SVGSVGElement> & { title?: string }>;
const FLAGS = Flags as unknown as Record<string, FlagComponent>;

interface CountryFlagProps {
  /** ISO 3166-1 alpha-2 country code (case-insensitive), e.g. "IN", "br". */
  code: string;
  /** Sizing/rounding classes — defaults to the Figma DS 18×13 rounded flag. */
  className?: string;
  /** Accessible label; defaults to the upper-cased code. */
  title?: string;
}

/**
 * Rectangular SVG country flag matching the Figma design-system "Flag pack"
 * (3:2, ~18×13, lightly rounded). Replaces the old emoji flags, which render
 * inconsistently across platforms (Windows shows the letters, not a flag).
 * Falls back to a globe glyph for unknown or aggregate ("_other") codes.
 */
export const CountryFlag: React.FC<CountryFlagProps> = ({ code, className, title }) => {
  const cc = (code ?? '').trim().toUpperCase().slice(0, 2);
  const Flag = /^[A-Z]{2}$/.test(cc) ? FLAGS[cc] : undefined;
  const cls = className ?? 'h-[13px] w-[18px] shrink-0 rounded-[2px] object-cover';
  if (!Flag) {
    return <Globe aria-label={title ?? 'Unknown region'} className={`${cls} text-muted-foreground`} />;
  }
  return <Flag title={title ?? cc} className={cls} />;
};
